import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderObjectBy',
  standalone: true,
  pure: true,
})
export class OrderObjectByPipe implements PipeTransform {
  transform<T>(
    items: ReadonlyArray<T> | Record<string, T> | null | undefined,
    field?: string,
    reverse: boolean = false
  ): T[] {
    if (!items) return [];

    // Support arrays or plain objects (like the AngularJS filter did)
    const arr: T[] = Array.isArray(items) ? [...items] : Object.values(items);

    // No field ⇒ just return (maybe reversed)
    if (!field) return reverse ? arr.reverse() : arr;

    // Safe getter (tolerant to missing props)
    const getVal = (obj: any) => (obj != null ? obj[field] : undefined);

    arr.sort((a: any, b: any) => {
      const va = getVal(a);
      const vb = getVal(b);

      // String-aware, locale-friendly compare
      if (typeof va === 'string' && typeof vb === 'string') {
        return va.localeCompare(vb);
      }

      // Fallback compare for numbers/other types (treat undefined as smallest)
      if (va == null && vb == null) return 0;
      if (va == null) return -1;
      if (vb == null) return 1;
      return va > vb ? 1 : va < vb ? -1 : 0;
    });

    return reverse ? arr.reverse() : arr;
  }
}
